export type PostsView = "list" | "calendar";

export function getPostsView(search: string | URLSearchParams): PostsView {
  const params =
    typeof search === "string" ? new URLSearchParams(search) : search;

  return params.get("view") === "list" ? "list" : "calendar";
}

export function postsSearchForView(
  search: string | URLSearchParams,
  view: PostsView,
): string {
  const params = new URLSearchParams(search);

  if (view === "list") {
    params.set("view", "list");
  } else {
    params.delete("view");
  }

  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : "";
}
